/*
JS file for cranktank / RPNA managed functions on impulse theme
Referenced in theme.liquid
If issues, reach out to taylor@cranktank.net
*/


/*
on variant change functions below.
Triggers should all be aggregated in "theme--ct-modified.js" below line 915
See here for working with json: https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Objects/JSON
*/
function log_variant(variant){
  //console.log(variant);
}

function find_light_icon(ltv){
  var src;

  //logic to determine the icon source
  if(ltv < 10){ //full sun
    src = "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_FullSun.svg?v=1645649610";
  } else if (ltv >10 && ltv < 20){//sun
    src= "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_Sun.svg?v=1645649609";
  } else if (ltv >20 && ltv < 30){//less sun
    src= "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_LessSun.svg?v=1645649613";
  } else if (ltv >30 && ltv < 40){//Partly Cloudy
    src = "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_PartlyCloudy.svg?v=1645649608";
  } else if (ltv > 40 && ltv < 50){//partly sunny
    src = "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_PartlySunny.svg?v=1645649613";
  } else if (ltv > 50 && ltv < 60){//snow
    src = "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_Snow.svg?v=1645649611";
  } else if (ltv > 60){//rain
    src = "https://cdn.shopify.com/s/files/1/2338/3111/t/132/assets/Rudy_WeatherIcons_Rain.svg?v=1645649614";
  } else {
    src = "not found"
  }
  return src;
}

// function updateStickyHeaderPrice(variant, compare_at_price, actual_price){
//   // first check if there is a sticky header
//   var ct_header_wrapper = document.querySelector(".ct-header-wrapper");
//   if (ct_header_wrapper) {
//     // update price, compare at price and inventory notice.
//     let ca_price = document.querySelector(".ct-header-wrapper [data-compareprice]"),
//     price = document.querySelector(".ct-header-wrapper .money"),
//     inventory_notice = document.querySelector(".ct-header-wrapper p.ct-inventory_notice"),
//     new_inventory_notice_product_form = document.querySelector(".product-block.product-block--sales-point[ct-block-type=\"inventory-status\"] span[data-product-inventory]");

//     if (ca_price) {
//       ca_price.innerText = compare_at_price;
//     }

//     if (inventory_notice) {
//       if (variant.inventory_quantity < 1) {
//         inventory_notice.innerText = "";
//       } else {
//         inventory_notice.innerText = new_inventory_notice_product_form.innerText;
//       }
//     }

//     if (price) {
//       price.innerText = actual_price;
//     }
//   }
// }

/*
code commented out for cranktank's image variant focus feature... rpna requested removal on 5/19/2022
function renderVariantImageFocus(variant){
  //console.log('variant image focus');
  //console.log(variant.sku);
  try{
    ct_process_images(variant.sku);
  } catch (error){
    //console.log(error);
    //console.log('render variant image focus tried, caught. file ct.js')
  }
}
*/

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
*/
function updateFrameLensesBumpers(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let frame_lens_titles_binary = ct_data['frame_lens_titles_binary'];
  if( product_type == "sunglass" && frame_lens_titles_binary ){
    //console.log('run function');
    //pull data
    let variant_id = variant['id'];

    //console.log(ct_data);
    let variant_metafields = ct_data['variant_metafields'];
    for(var i = 0; i < variant_metafields.length; i++){
      if(variant_metafields[i]['variant_id'] == variant_id){
        var frame = variant_metafields[i]['sunglass_frame_name'];
        var lenses = variant_metafields[i]['sunglass_lenses_name'];
        var bumper = variant_metafields[i]['sunglass_bumper_name'];
        var light_low = variant_metafields[i]['lens_light_transmission_low'];
        var light_high = variant_metafields[i]['lens_light_transmission_high'];
        break;
      }
    }
    //console.log(frame);
    //console.log(lenses);
    //console.log(bumper);

    //place data
    document.querySelector('span.variant__label-info[ct-variant-metafield="frame"]').innerText = "Frame: "+frame;
    document.querySelector('span.variant__label-info[ct-variant-metafield="lenses"]').innerText = "Lenses: "+lenses;
    if(bumper){
      document.querySelector('span.variant__label-info[ct-variant-metafield="bumpers"]').innerText = "Bumpers: "+bumper;
    }
    if(light_low && light_high){
      //console.log('both lenses');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      var light_low_icon = find_light_icon(light_low);
      var light_high_icon = find_light_icon(light_high);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').src = light_high_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.remove("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.remove("ct-hidden");
    } else if(light_low){
      //console.log('lens low');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"%";
      var light_low_icon = find_light_icon(light_low);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.add("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.add("ct-hidden");
    } else {
      //console.log('nadda lens');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: unset";
    }
  } else {
    //console.log('dont run frame lens bumper function');
  }
}

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
*/
function updateLensDetails(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let lens_titles_binary = ct_data['lens_titles_binary'];
  if( product_type == "lenses" && lens_titles_binary ){
    //console.log('update lens values');
    let variant_id = variant['id'];

    //console.log(ct_data);
    let variant_metafields = ct_data['variant_metafields'];
    for(var i = 0; i < variant_metafields.length; i++){
      //find data
      //console.log(variant_id);
      if(variant_metafields[i]['variant_id'] == variant_id){
        var lenses = variant_metafields[i]['sunglass_lenses_name'];
        var light_low = variant_metafields[i]['lens_light_transmission_low'];
        var light_high = variant_metafields[i]['lens_light_transmission_high'];
        break;
      }
    }

    //place data
    document.querySelector('span.variant__label-info[ct-variant-metafield="lenses"]').innerText = lenses;
    if(light_low && light_high){
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      var light_low_icon = find_light_icon(light_low);
      var light_high_icon = find_light_icon(light_high);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').src = light_high_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.remove("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.remove("ct-hidden");
    } else if(light_low){
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"%";
      var light_low_icon = find_light_icon(light_low);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.add("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.add("ct-hidden");
    } else {
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "";
    }

  } else {
    //console.log('do nothing');
  }
}

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
*/
function updateHelmetColor(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let helmet_color_title_replacement_binary = ct_data['helmet_color_title_replacement'];
  if(product_type == "helmet" && helmet_color_title_replacement_binary ){
    //if product type == helmets and if the user checked the box off, then run function
    //console.log('execute function');
    let variant_id = variant['id'];
    let variant_metafields = ct_data['variant_metafields'];

    //pull variant data when found.
    for(var i = 0; i < variant_metafields.length; i++){
      if(variant_metafields[i]['variant_id'] == variant_id) {
        var helmet_color = variant_metafields[i]['helmet_color'];
        break;
      }
    }

    //place data
    document.querySelector('div.variant-wrapper label.variant__label span.variant__label-info span').innerText = helmet_color;

  } else {
    //else, don't run the function
    //console.log('dont update helmet color');
  }
}

/*
display ltv box
*/
function displayLtvBox(){
  //pull data
  var smallArrow = document.querySelector("span.ct-variant-learn-more svg");
  var wrapper = document.querySelector("span.ct-variant__label-wrapper[ct-status]");
  //change classes, etc
  if(wrapper.getAttribute("ct-status") == "collapsed"){
    smallArrow.classList.add("rotated");
    wrapper.setAttribute("ct-status","visible");
  } else {
    smallArrow.classList.remove("rotated");
    wrapper.setAttribute("ct-status","collapsed");
  }
}

/*display accordion boxes on bold*/
function ctAccordionNew(variable){
  var carrot = variable.querySelector(".down-carot-wrapper");
  var panel = variable.querySelector("div.accordion-panel");
  var classList = panel.classList;
  var proceed = true;
  for (var i = 0; i < classList.length; i++){
    if ( classList[i] == 'accordion-hidden' ){
      proceed = false;
      break;
    }
  }
  //console.log(proceed);
  if(proceed){
    //panel.setAttribute("style","");
    panel.classList.remove("accordion-open");
    panel.classList.add("accordion-hidden");
    carrot.classList.add("new-open");
    carrot.classList.remove("new-closed");
  } else {
    panel.classList.add("accordion-open");
    panel.classList.remove("accordion-hidden");
    carrot.classList.remove("new-open");
    carrot.classList.add("new-closed");
  }
}
function ctAccordion(variable){
  var carrot = variable.querySelector(".down-carot-wrapper");
  var panel = variable.parentElement.children[1];
  var classList = panel.classList;
  var proceed = true;
  for (var i = 0; i < classList.length; i++){
    if ( classList[i] == 'open' ){
      proceed = false;
      break;
    }
  }
  if(proceed){
    panel.setAttribute("style","");
    panel.classList.add("open");
    carrot.classList.add("open");
  } else {
    panel.classList.remove("open");
    carrot.classList.remove("open");
  }
}
